import { Container, Row, Col } from "react-bootstrap";
import { InternationalDoctorCard } from "../../Components/ui/InternationalDoctorCard/InternationalDoctorCard";
import { internationalDoctors } from "../../data/internationalDoctors";
import heroBg from "../../assets/images/aboutus-bg.png";
import "./internationaldoctercollaborations.css";

export const Internationaldoctercollaborations = () => {
  return (
    <div className="idc-page">
      {/* ── Hero Banner ── */}
      <section
        className="store-page__hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">
              International Collaborations
            </p>
            <h1 className="store-page__hero-title">
              Learn from leading doctors and specialists through focused,
              digestible video content.
            </h1>
          </Container>
        </div>
      </section>

      {/* ── Doctors Grid ── */}
      <section className="idc-doctors">
        <Container>
          <h2 className="idc-doctors__heading">Doctors Joined Bizaario</h2>
          <p className="idc-doctors__sub">
            Learn from leading doctors and specialists through focused,
            digestible video content.
          </p>

          <Row className="g-4">
            {internationalDoctors.map((doctor) => (
              <Col key={doctor.id} xs={12} sm={6} lg={4}>
                <InternationalDoctorCard
                  avatar={doctor.avatar}
                  name={doctor.name}
                  onViewProfile={() => {}}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};
